import React from 'react';
import PropTypes from 'prop-types';
// Import Shared Utils
import { formatExpiryDate } from 'shared-components/src/utils/formatDateTime';
// Import Global Components
import SectionOne from '../../../components/SectionOne';
// Import Local Components
import CardInfo from './CardInfo';
// Import Translations
import { recoverEn } from '../../../i18n/recover';

const SectionOneWrapper = ({
  name,
  address,
  number,
  expiry,
  cardSecurityCode,
  iframeUrl,
  ...props
}) => (
  <SectionOne
    page="recovered"
    label={recoverEn['recovered-sectionOne-label']}
    name={name}
    number={number}
    expiry={expiry}
    iframeUrl={iframeUrl}
    {...props}
  >
    <CardInfo
      labelFor="name"
      label={recoverEn['recovered-name-label']}
      info={name}
    />
    <CardInfo
      labelFor="address"
      label={recoverEn['recovered-address-label']}
      info={address}
    />
    {/* Card fields render inside the hosted iframe for iframe-enabled programs */}
    {!iframeUrl && (
      <>
        <CardInfo
          labelFor="cardNumber"
          label={recoverEn['recovered-cardNumber-label']}
          info={number}
        />
        <CardInfo
          labelFor="expiry"
          label={recoverEn['recovered-expiry-label']}
          info={formatExpiryDate(expiry)}
        />
        <CardInfo
          labelFor="cvv"
          label={recoverEn['recovered-cvv-label']}
          info={cardSecurityCode}
        />
      </>
    )}
  </SectionOne>
);

SectionOneWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  number: PropTypes.string,
  expiry: PropTypes.string,
  cardSecurityCode: PropTypes.string,
  iframeUrl: PropTypes.string,
};

SectionOneWrapper.defaultProps = {
  number: null,
  expiry: null,
  cardSecurityCode: null,
  iframeUrl: null,
};

export default SectionOneWrapper;
